module.exports = __webpack_public_path__ + "img/DSC07650.1fb40bfa.jpg";